import React, { useEffect, useState } from "react";
import { Box, Checkbox, FormControlLabel } from "@mui/material";
import Grid from "@mui/material/Grid";
import Paper from "../../../Components/UI/Paper";
import Typography from "@mui/material/Typography";

import { useNavigate } from "react-router-dom";
import { createBookBulk } from "API/swesum";

import Button from "@mui/material/Button";

import { usePopupNotificationContext } from "Context/NotificationPopup";
import CreateBooksForm from "./componentes/CreateBooksForm";
import { useClients } from "Context/Clients";
import { useAccountCharts } from "Context/AccountCharts";
import { LoadingButton } from "@mui/lab";
import dayjs from "dayjs";

const initRows = [
  { id: 0, accountId: "", name: "", debet: null, credit: null },
  { id: 1, accountId: "", name: "", debet: null, credit: null },
  { id: 2, accountId: "", name: "", debet: null, credit: null },
];

export function CreateBooks() {
  const navigate = useNavigate();
  const { clients, fetchClients } = useClients();
  const { fetchAccountCharts, accountCharts } = useAccountCharts();
  const { openError, openSuccess } = usePopupNotificationContext();
  const [enableSaveButton, setEnableSaveButton] = useState(false);
  const [skipValidation, setSkipValidation] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [formData, setFormData] = useState({
    clientId: null,
    comment: "",
    date: dayjs(new Date()).format("YYYY-MM-DD"),
    rows: [...initRows],
  });
  const handleDataChange = (updatedData) => {
    setFormData(updatedData);
  };

  useEffect(() => {
    const asyncInitView = async () => {
      fetchClients();
      fetchAccountCharts();
    };
    asyncInitView();
  }, []);

  const submit = async () => {
    setIsLoading(true);

    try {
      if (!skipValidation) {
        if (!hasValidRows(formData)) {
          openError("Kontrollera att alla rader är korrekt ifyllda.", 3000);
          return;
        }

        if (!hasValidDate(formData)) {
          openError("Du måste fylla i ett giltigt datum.", 3000);
          return;
        }
      }

      const body = {
        Books: formData.rows.map((row) => ({
          AccountChartId: row.accountId,
          DebetAmount: row.debet ?? 0,
          KreditAmount: row.credit ?? 0,
          Description: `${formData.comment} ${row.name}`,
          ClientId: formData.clientId,
          BookDate: formData.date,
        })),
        SkipValidation: skipValidation,
      };

      const res = await createBookBulk(body);
      openSuccess(`Skapade ${res.data.length} st nya bokföringsrader.`, 1500);
      setTimeout(() => {
        navigate("/books");
      }, 1500);
    } catch (err) {
      console.log(err);
      openError("Något gick fel.", 3000);
    } finally {
      setIsLoading(false);
    }
  };

  const hasValidDate = (formData) => {
    return formData.date && formData.date !== "Invalid Date";
  };

  const hasValidRows = (formData) => {
    return formData.rows.every((row) => row.accountId);
  };

  return (
    <>
      <Box component="main" sx={{ flexGrow: 1, overflow: "auto" }}>
        <Box sx={{ flexGrow: 1, pt: 8, pb: 3, pl: 3, pr: 3 }}>
          <Grid
            container
            rowSpacing={1}
            columnSpacing={{ xs: 1, sm: 2, md: 3 }}
          >
            <Grid item xs={12} md={12}>
              <Paper>
                <Typography
                  sx={{ marginBottom: "1.0rem" }}
                  variant="h5"
                  align="left"
                >
                  Skapa bokföring
                </Typography>
                <CreateBooksForm
                  clients={clients}
                  accounts={accountCharts}
                  setEnableSaveButton={setEnableSaveButton}
                  onDataChange={handleDataChange}
                  initFormData={formData}
                />
                <Grid
                  item
                  xs={12}
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    mt: 1,
                  }}
                >
                  <Button onClick={() => navigate(-1)}>Stäng</Button>
                  <LoadingButton
                    loading={isLoading}
                    onClick={submit}
                    variant="contained"
                    sx={{ ml: 3 }}
                    disabled={
                      !skipValidation &&
                      (!enableSaveButton ||
                        !hasValidDate(formData) ||
                        !hasValidRows(formData))
                    }
                  >
                    Spara
                  </LoadingButton>
                </Grid>
              </Paper>

              <FormControlLabel
                sx={{ width: "100%", justifyContent: "end" }}
                control={
                  <Checkbox
                    checked={skipValidation}
                    onChange={(e) => setSkipValidation(e.target.checked)}
                  />
                }
                label="Tillåt utan validering"
              />
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  );
}
